import { Component, OnInit, Host } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ProteinSearchService } from '../services/protein-search.service';
import { database } from '../carousel';



@Component({
  selector: 'app-protein-search-result',
  templateUrl: './protein-search-result.component.html',
  styleUrls: ['./protein-search-result.component.css']
})
export class ProteinSearchResultComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private proteinSearchService: ProteinSearchService
  ) { }

  ngOnInit() {
    this.proteinResult;

    this.route.paramMap.subscribe(params => {
      this.selectedProperty = params.get('property');
      this.searchValue = params.get('searchValue');
      this.page = params.get('page');
    })

    this.loading = true;

    this.proteinSearchService.getSearchResultList(this.selectedProperty, this.searchValue, this.page)
      .subscribe((data) => {
        this.proteinResult = data;
        this.proteinList = this.proteinResult.content;
        this.total = this.proteinResult.totalPages;
        this.pageIndex = this.proteinResult.number + 1;
        this.totalElements = this.proteinResult.totalElements;
        this.loading = false;
      })

  }

  selectedProperty;
  searchValue;
  page;

  proteinResult: any;
  proteinList: []
  total: number;
  pageIndex: number;
  totalElements: number;

  loading = true;

  changePage(event) {
    alert(event);
  }

}
